module.exports = __webpack_public_path__ + "img/sup_deposit_vega2.94e54ddd.jpg";